import { gql } from "apollo-angular";

export default gql`
  mutation VerifyMfaOtp($input: VerifyMfaOtpInput!) {
    verifyMfaOtp(input: $input) {
      payload {
        firstName
        lastName
        email
        role
        userId
        companiesIds
      }
      access_token
      refresh_token
    }
  }
`;
